module.exports = __webpack_public_path__ + "static/media/origami1.0745badc.jpg";